module.exports = __webpack_public_path__ + "google_pixel-silver-landscape@2x.png?5fa1c0d965ec41f42c1756484817c81b";